var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeligramHomeBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#131313"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9872_7511)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4809 11.6916C24.6868 11.605 24.9122 11.5751 25.1336 11.6051C25.355 11.6351 25.5643 11.7239 25.7398 11.8622C25.9152 12.0006 26.0504 12.1834 26.1312 12.3917C26.212 12.6 26.2355 12.8262 26.1992 13.0466L24.3092 24.5108C24.1259 25.6166 22.9125 26.2508 21.8984 25.7C21.05 25.2391 19.79 24.5291 18.6567 23.7883C18.09 23.4175 16.3542 22.23 16.5675 21.385C16.7509 20.6625 19.6675 17.9475 21.3342 16.3333C21.9884 15.6991 21.69 15.3333 20.9175 15.9166C18.9984 17.365 15.9192 19.5675 14.9009 20.1875C14.0025 20.7341 13.5342 20.8275 12.9742 20.7341C11.9525 20.5641 11.005 20.3008 10.2317 19.98C9.1867 19.5466 9.23754 18.11 10.2309 17.6916L24.4809 11.6916Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9872_7511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeligramHomeBlack);
export default __webpack_public_path__ + "static/media/teligram-home-black.323a9d2e597a1d0b178744f6d4c6069c.svg";
export { ForwardRef as ReactComponent };